import { get, head, isArray } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormInputProps } from './props';

interface Props extends Pick<FormInputProps, 'name'> {}

export const FormErrorMessage: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ name }: Props) => {
    const {
        formState: { errors }
    } = useFormContext();
    const fieldErrors = get(errors, name);
    const error = (isArray(fieldErrors) ? head(fieldErrors.filter((v) => v)) : fieldErrors)?.message;

    // data-form-error lets step wizards find and scroll to the first visible error
    return error ? (
        <p data-form-error={name} className="tw-mb-0 tw-text-sm tw-text-error">
            {error}
        </p>
    ) : null;
};

export default FormErrorMessage;
